export class ApplicationSessionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getActiveApplicationSession() {
    return this.#http.get('/ApplicationSession/active');
  }
}
